<template>
  <div :class="classStyle">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    col: {
      type: Number,
      default: 1,
    },
    justify: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: null,
    },
  },
  computed: {
    classStyle() {
      const { col, justify, align } = this
      const justifyClass = justify ? `v-col--justify-content-${justify}` : null
      const alignClass = align ? `v-col--align-items-${align}` : null
      return ['v-col', `v-col-${col}`, justifyClass, alignClass]
    },
  },
}
</script>

<style lang="scss" scoped>
.v-col,
.v-col-1 {
  display: flex;
  flex-direction: column;
  padding: 6px;
  padding-top: 0;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
}

.v-col-1 {
  flex: 1;
}

.v-col--justify-content-center {
  justify-content: center;
}
.v-col--justify-content-end {
  justify-content: flex-end;
}
.v-col--justify-content-start {
  justify-content: flex-start;
}

.v-col--align-items-center {
  align-items: center;
}
.v-col--align-items-end {
  align-items: flex-end;
}
.v-col--align-items-start {
  align-items: flex-start;
}
</style>
